// import { Preferences } from '@capacitor/preferences';

// const setName = async () => {
//     await Preferences.set({
//         key: 'name',
//         value: 'Max',
//     });
// };

// const checkName = async () => {
//     const { value } = await Preferences.get({ key: 'name' });

//     console.log(`Hello ${value}!`);
// };

// const removeName = async () => {
//     await Preferences.remove({ key: 'name' });
// };




// import { SplashScreen } from '@capacitor/splash-screen';

// // Hide the splash (you should do this on app launch)
// await SplashScreen.hide();

// // Show the splash for an indefinite amount of time:
// await SplashScreen.show({
//     autoHide: false,
// });

// // Show the splash for two seconds and then automatically hide it:
// await SplashScreen.show({
//     showDuration: 2000,
//     autoHide: true,
// });




// capacitor status bar
import { StatusBar,  } from '@capacitor/status-bar';
const statusBarOption = {
    color: "#2d3799"
}
StatusBar.setBackgroundColor(statusBarOption);

//capacitor storage
import { Preferences } from '@capacitor/preferences';
export async function storeData(data) {
    const { key, value } = data;
    await Preferences.set({
        key: key.toString(),
        value: value
    });
}

// JSON "get" example
export async function getStoredData(key) {
    const data = await Preferences.get({ key: key.toString() });
    return data.value;
}

//capacitor config
import { SplashScreen } from "@capacitor/splash-screen";
// Show the splash for two seconds and then automatically hide it:
(async function injectCapacitor() {
    await SplashScreen.show({
        showDuration: 2000,
        autoHide: true,
    });
});